import { useState, useEffect } from "react"

import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons"
import { List, Space, Modal, Spin } from "antd"

import variables from "@/_styles/variables.module.scss"
import { getLastUpdateFromSoap } from "@/http/authorities"

import classes from "./AuthorityProcessLog.module.scss"

import { IAuthorityProcessLog } from "@/types/IProcessLog"

import { dateTimeFormat, formatDate } from "@/utils/formatDate"

interface AuthorityProcessLogProps {
  open: boolean
  onCancel: () => void
  onSubmit: () => void
}

export const AuthorityProcessLog = (props: AuthorityProcessLogProps) => {
  const { open, onSubmit, onCancel } = props

  const [processLog, setProcessLog] = useState<IAuthorityProcessLog>()
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(()  => {
    if(open) {
      setLoading(true)
    }
  }, [open])

  useEffect(()  => {    
    if (open && loading) {
      setTimeout(getProcessLog, 3000)
    }
  }, [loading])

  const submitHandler = () => {
    setLoading(true)
    setProcessLog(undefined)
    onSubmit()
  }

  const getProcessLog = async () => {
    const response = await getLastUpdateFromSoap()
    let isGetRequest = loading
    if (response.response === null) {
      setLoading(false)
      isGetRequest = false
    } else if (response.succeeded && response.response) {
      setProcessLog(response.response)

      if (response.response.status === 2 || response.response.status === 3) {
        setLoading(false)
        isGetRequest = false
      }
    }

    if (open && isGetRequest) {
      setTimeout(getProcessLog, 3000)
    }
  }

  const isDisabledOkButton = loading

  return (
    <Modal
      open={open}
      centered={true}
      onCancel={onCancel}
      title="Обновление доверенностей из 1C"
      okText="Обновить"
      okButtonProps={{ disabled: isDisabledOkButton }}
      cancelText="Закрыть"
      onOk={submitHandler}
    >
      <Spin size="small" spinning={loading} >
        <div className={classes.modalBody}>

        </div>
        {!processLog && !loading  &&
          <div>
            Нет ифнормации по последнему обновлению
          </div>
        }
        {processLog &&
          <div>
            <div>
              Информация по последнему обновлению
            </div>
            <div>
              Обновление началось в {formatDate(processLog.startDate as Date, dateTimeFormat)}
            </div>
            {processLog.endDate &&
              <div>
                Обновление закончилось в {formatDate(processLog.endDate, dateTimeFormat)}
              </div>
            }
            <div>
              Всего доверенностей в обработке: {processLog.data.count}
            </div>
            <div>
              Статус: {processLog.statusText}
            </div>
            <List>
              {processLog.data.items?.map((item, idx) => (
                <List.Item key={idx}>
                  <Space>
                    <span>
                      {item.status === 0 ? (
                        <CheckCircleOutlined style={{ color: variables.textGreenColor }} />
                      ):(
                        <CloseCircleOutlined style={{ color: variables.textRedColor }}/>
                      )}
                    </span>
                    <span>{item.statusText} по доверенности с номером "{item.authorityNumber}"</span>
                  </Space>
                </List.Item>
              ))}
            </List>
          </div>
        }
      </Spin>
    </Modal>
  )
}
